import { useEffect, useRef } from 'react';
import { useTheme } from 'next-themes';
import { useOrgBranding } from './useOrgBranding';

/**
 * Applies the organization's default theme (light/dark) for users
 * who haven't explicitly set their own theme preference.
 */
export function useOrgDefaultTheme() {
  const { defaultTheme, loading } = useOrgBranding();
  const { setTheme } = useTheme();
  const appliedRef = useRef(false);

  useEffect(() => {
    if (loading || appliedRef.current) return;

    // Respect user's explicit choice
    const userChoice = localStorage.getItem('pwa-atkomst-theme');
    if (userChoice) return;

    if (defaultTheme) {
      setTheme(defaultTheme);
      appliedRef.current = true;
    }
  }, [defaultTheme, loading, setTheme]);
}
